<template>
  <ul class="schedule-switch-list">
    <li
      v-for="s in schedules"
      :id="s.scheduleId"
      class="item"
      :class="{ 'disable': isDisabled(s), 'selected': s.scheduleId === currentId}"
      :key="s.scheduleId"
      @click.stop="onScheduleClick(s)"
    >
      <div class="start-at">{{s.showAt | date_show_time}}</div>
      <div class="language">{{s.filmLanguage + s.imagery}}</div>
      <div class="price">
        <span class="price-icon">￥</span>
        <span>{{ s.minSalePrice | schedule_price }}</span>
        <span class="upon" v-if="isSectionPrice(s)">起</span>
      </div>
    </li>
  </ul>
</template>

<script>
import { Toast } from 'mint-ui'
import { isStopSelling } from '@util/function'
import DecimalPrice from '@comp/decimal-price'

export default {
  name: 'scheduleList',
  components: {
    'decimal-price': DecimalPrice,
  },
  props: {
    schedules: {
      type: Array,
      default: [],
    },
    defaultSchduleId: {
      type: [String, Number],
    },
    isSwitching: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentId: Number(this.defaultSchduleId),
      isFirst: true,
    }
  },
  watch: {
    defaultSchduleId(newVal, oldVal) {
      if (!newVal) {
        return
      }
      const newId = Number(newVal)
      if (newId !== this.currentId) {
        this.currentId = newId
      }
    },
    isSwitching(newVal, oldVal) {
      if (newVal && this.isFirst) {
        const child = document.getElementById(this.currentId)
        const parent = document.querySelector('.schedule-switch-list')
        // 滚动到已选元素位置
        parent.scrollLeft = child.offsetLeft
        this.isFirst = false
      }
    },
  },
  methods: {
    isDisabled(schedule) {
      return isStopSelling(schedule.showAt, schedule.advanceStopMins)
    },
    // 分区定价
    isSectionPrice(schedule) {
      return schedule.minSalePrice !== schedule.maxSalePrice
    },
    onScheduleClick(schedule) {
      if (this.currentId === schedule.scheduleId) {
        return
      }

      if (this.isDisabled(schedule)) {
        return Toast({
          message: '当前场次已经停止售票，请选择其他场次。',
          position: 'bottom',
          duration: 3000,
        })
      }

      this.currentId = schedule.scheduleId
      this.$emit('scheduleChange', schedule.scheduleId)
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';
@disableWhite: rgb(210, 214, 220);

.schedule-switch-list {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  overflow-x: scroll;
  .disable {
    .start-at {
      color: @disableWhite !important;
    }
    .language {
      color: @disableWhite !important;
    }
    .price {
      color: @disableWhite !important;
    }
  }
  .item {
    min-width: 70px;
    height: 60px;
    flex-shrink: 0;
    margin-right: 10px;
    padding: 6px 0;
    background-color: rgba(244, 244, 244, 0.6);
    border-radius: 2px;
    text-align: center;
    box-sizing: border-box;
    .start-at {
      font-size: 14px;
      color: #191a1b;
      line-height: 17px;
    }
    .language {
      font-size: 10px;
      color: @lightSliver;
      width: 60px;
      line-height: 14px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin: 0 auto;
      margin-top: 1px;
    }
    .price {
      font-size: 13px;
      color: #797d82;
      .price-icon,
      .upon {
        font-size: 8px;
      }
    }
  }
  .item.selected {
    background-color: #fffbfb;
    position: relative;

    &::after {
      .setBorderLine(#ff5f16);
    }
  }
}
</style>



